import { render } from "./IQToolMiddlePaneHeader.vue?vue&type=template&id=5b36e59e&scoped=true&lang=pug"
import script from "./IQToolMiddlePaneHeader.js?vue&type=script&lang=js&external"
export * from "./IQToolMiddlePaneHeader.js?vue&type=script&lang=js&external"

import "./IQToolMiddlePaneHeader.vue?vue&type=style&index=0&id=5b36e59e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b36e59e"]])

export default __exports__